var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-icon',{staticClass:"h3 mb-0 download",attrs:{"disabled":!_vm.columns || !_vm.content,"icon":"cloud-download","aria-hidden":"true"},on:{"click":_vm.handleDownloadClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }